import { format } from "date-fns";

import { LanguageType } from "types/index";
import { DEFAULT_VALUE, JAPANESE_DATE_DISPLAY_FORMAT } from "constants/index";

const isValidDateValue = (value?: Date) => {
  if (!value) return false;
  return !Number.isNaN(value.getTime());
};

export const resolveJapaneseFormat = (formatString?: string) => {
  if (!formatString) return JAPANESE_DATE_DISPLAY_FORMAT;

  if (formatString.includes("yyyy/MM/dd")) {
    return formatString.replace("yyyy/MM/dd", JAPANESE_DATE_DISPLAY_FORMAT);
  }

  if (formatString.includes("yyyy/MM")) {
    return formatString.replace("yyyy/MM", "yyyy年MM月");
  }

  return JAPANESE_DATE_DISPLAY_FORMAT;
};

export const formatLocalizedDate = (
  date: string | number | Date | null | undefined,
  language: LanguageType,
  fallbackFormat: string = DEFAULT_VALUE.DATE_FORMAT
) => {
  if (!date) return "";

  const parsedDate = date instanceof Date ? date : new Date(date);

  if (!isValidDateValue(parsedDate)) return "";

  const formatString =
    language === "ja" ? resolveJapaneseFormat(fallbackFormat) : fallbackFormat;

  return format(parsedDate, formatString);
};
